
import React from "react";
import SsoButtons from "../components/SsoButtons.js";

export default class LinkAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  componentDidMount = () =>  {
  }

closeMe = () =>  {
  this.props.close(false);
}





  render() {
    return (
            <div className="LinkAccount floating-dialog">
            <div className="close" onClick={() => this.props.close(false)}><i className="fa fa-times-circle"></i></div>
            <div className="me-4">
            <h3 className="m-2">Here you can link your Google or Microsoft account to make logging in much easier.</h3>
            </div>
            <SsoButtons type="link" close={this.closeMe}/>
            </div>
           )
   }
 }
